<template>
    <b-navbar v-if="mounted" toggleable="md" :type="s_skinVariant" :variant="s_skinVariant" class="action-bar cadfm-flexitem-fixed">
        <b-navbar-toggle :target="id"></b-navbar-toggle>
        <b-collapse is-nav :id="id">
            <slot></slot>
        </b-collapse>
    </b-navbar>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
import { mapGetters } from 'vuex'
export default {
  name: 'ActionBar',
  data () {
    return {
        mounted:false,
        id: null
    }
  },
  mounted () {
    this.mounted=true;
    this.id = 'action-bar-'+this._uid.toString();
  },
  computed:{
        ...mapGetters({

        s_skinVariant: 's_skinVariant',

        }),
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

    /*@import 'main.scss';*/
  .action-bar  {
      /*font-size: 0.75rem;*/
  }


  .action-bar .navbar-nav>* {
      margin: 3px 3px;
  }

  .action-bar.navbar {
      padding:0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/ActionBar.vue